// Vendor
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

// App
import { OrderService } from "../../services/order/order.service";

// Config
import {
    PATH_STEP_1,
    PATH_STEP_2,
    PATH_STEP_3,
} from "../../app-routing.constants";

@Component({
    selector: "ig-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
    constructor(public orderService: OrderService, private router: Router) {}

    public get whereCostsVisibleUrls() {
        const addLeadingSlash = (str: string) => `/${str}`;
        return [PATH_STEP_1, PATH_STEP_2, PATH_STEP_3].map(addLeadingSlash);
    }

    public get hideCosts() {
        return (
            this.orderService.total <= 0 ||
            this.whereCostsVisibleUrls.indexOf(this.router.url) === -1
        );
    }

    ngOnInit() {}
}
